
// import Vue from 'vue'

export default {
  name: 'OpenBookIcon',
}
